// extracted by mini-css-extract-plugin
export default {"p":"ead8a3087a _7cd9be073b _0d32bfbb0a","clr":"a105675c1e","dls":"_6b60ae0acf"};